import { OfbizList, OfbizForm, FieldSet, OfbizField } from "@urbannex/ofbiz-forms";
import { ConfigOptions, ComponentConfig, getColumnFieldTitles, getFields, getTarget, getTargets } from "@urbannex/view-containers";
import { IMG_FORMS } from "./forms";
import { NbMenuItem } from "@nebular/theme";

export const imageOptions:ConfigOptions = {
    name:"",
    title:"Image Management Component",
    menuAndTitleOptions:{
      path:"img",
      headerTitle:"Image",
      menuItems:[],
      menuTag:"imageMenu"
  },
    listForm:new OfbizList({
      listType:"grid",
      listFormName:"ListProductCategoryMembers",
      listFormLocation:"component://kwikstore/widget/ImageManagementForms.xml",
      columnFields:getFields("ListProductCategoryMembers",IMG_FORMS),
      columnFieldTitles:getColumnFieldTitles("ListProductCategoryMembers",IMG_FORMS),
      appContext:"catalog",
      emptyListMessage:"No products found in this catalog. Use the product Manager to add products.",
      remoteFormData:{
        formData:{
          formName:"ListProductCategoryMembers",
          formLocation:"component://kwikstore/widget/ImageManagementForms.xml",
          viewIndex:0,
          listType:"grid",
        },
        appContext:"catalog",
        parameters:{"productCategoryId":"CATALOG1_SEARCH"}

      }
    }),
    addForm:undefined,
    findForm:undefined,
    breadCrumbData:{
      displayPrefix:"Product Galleries",
      label:"",
      level:1,
      selectedValue:{
        "event":"list",
        "type":"ListProductCategoryMembers",
        "data":{
          formData:{
            formName:"ListProductCategoryMembers",
            formLocation:"component://kwikstore/widget/ImageManagementForms.xml",
            listType:"grid"
          },
          "endPoint":""
        }
      },
      addFormText:"Create Product Gallery",
      editFormText:"Update Product Gallery"
    },
    masterDetails:[
      {
        title: "Product Images",
        addContainerTitle: "Add Product Image",
        listContainerTitle: "Product Image Gallery",
        keyMap: { fieldName: "productId" },
        addFormName: "",
        listFormName: "ProductImages",
        listForm:new OfbizList({
                listType:"grid",
                listFormName:"ProductImages",
                listFormLocation:"component://kwikstore/widget/ImageManagementForms.xml",
                columnFields:getFields("ProductImages",IMG_FORMS),
                columnFieldTitles:getColumnFieldTitles("ProductImages",IMG_FORMS),
                appContext:"catalog",
                emptyListMessage:"No images found for this product. Use the Image Manager to add images.",
                cardMode:true,
                remoteFormData:{
                    formData:{
                      formName:"ProductImages",
                      formLocation:"component://kwikstore/widget/ImageManagementForms.xml",
                      viewIndex:0,
                      listType:"grid",
                    },
                    appContext:"catalog",
                    parameters:{"productId":""}
                  }
            }),
        addForm:new OfbizForm({
            formName:"EditProductImage",
            formLocation:"component://kwikstore/widget/ImageManagementForms.xml",
            appContext:"kwikstore",
            fields:getFields("EditProductImage",IMG_FORMS),
            target:getTarget("EditProductImage",IMG_FORMS),
            targets:getTargets("EditProductImage",IMG_FORMS),
            layout:"SingleColumn",
            idFieldName:"contentId",
            breadCrumbData:{
              displayPrefix:"Product Image",
              addFormText:"Edit Product Image",
              editFormText:"Edit Product Image",
              data:{
                  formData:{
                      formName:"EditProductImage",
                      formLocation:"component://kwikstore/widget/ImageManagementForms.xml",
                  },
                  endPoint:getTarget("EditProductImage", IMG_FORMS),
                  parameters:{
                      contentId:"",
                  }
              }
          }
        }),
        
        
      }
    ],
    relations:[
      {
        title: "Add Images",
        addContainerTitle: "Create New Image",
        listContainerTitle: "Images",
        keyMap: { fieldName: "productId" },
        addFormName: "AddProductImage",
        listFormName: "ProductImages",
        addForm: new OfbizForm({
          title: "Upload Product Image",
          layout: "SingleColumn",
          appContext:"kwikstore",
          formLocation : "component://kwikstore/widget/ImageManagementForms.xml",
          fields: getFields("AddProductImage",IMG_FORMS),
          formName: "AddProductImage",
          target:getTarget("AddProductImage",IMG_FORMS),
          targets:getTargets("AddProductImage",IMG_FORMS),
          idFieldName: "productId",
          id: "productId",
          titleDescriptionField: "",
          collapsible: false,
          breadCrumbData: {
            displayPrefix:"Product Image",
            addFormText:"Upload Product Image",
            editFormText:"Upload Product Image",
            data:{
                formData:{
                    formName:"AddProductImage",
                    formLocation:"component://kwikstore/widget/ImageManagementForms.xml",
                },
                endPoint:getTarget("AddProductImage", IMG_FORMS),
                parameters:{
                    productId:"",
                }
            }
          }
        }),
        listForm:new OfbizList({
          listType:"grid",
          listFormName:"ProductImages",
          listFormLocation:"component://kwikstore/widget/ImageManagementForms.xml",
          columnFields:getFields("ProductImages",IMG_FORMS),
          columnFieldTitles:getColumnFieldTitles("ProductImages",IMG_FORMS),
          appContext:"catalog",
          emptyListMessage:"No images found for this product. Use the Image Manager to add images.",
          cardMode:true,
          remoteFormData:{
              formData:{
                formName:"ProductImages",
                formLocation:"component://kwikstore/widget/ImageManagementForms.xml",
                viewIndex:0,
                listType:"grid",
              },
              appContext:"catalog",
              parameters:{"productId":""}
            }
      }),
      }
    ],
    settings:[],
    actions:[]
}

